import { Retailer_Network_User_Role } from '@occc/graphql';

export const userRolesDropdownOptions = [
  {
    label: 'Site Admin',
    role: Retailer_Network_User_Role.SiteAdmin,
  },
  {
    label: 'Site User',
    role: Retailer_Network_User_Role.SiteUser,
  },
];
